function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#93ABB9;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Line_4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M192.5,151.3h-3.1c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3.1c0.8,0,1.5,0.7,1.5,1.5S193.3,151.3,192.5,151.3 z"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Line_5"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M179.9,149.8c0,0.8-0.7,1.5-1.5,1.5H173c1.1-1,2.2-2,3.2-3h2.2C179.2,148.3,179.9,149,179.9,149.8z"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Line_7"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M16.8,151.3H8.1c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h8.7c0.8,0,1.5,0.7,1.5,1.5S17.6,151.3,16.8,151.3z"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M138.2,37.9H29.9c-6.1,0-11,4.9-11,11v75.8c0,6.1,4.9,11,11,11h42.9v12.6h-50c-0.8,0-1.5,0.7-1.5,1.5 s0.7,1.5,1.5,1.5h91.8c-1.1-1-2.1-2-3.1-3H95.3v-12.6h7.6c-0.4-1-0.8-2-1.2-3H29.9c-4.4,0-8-3.6-8-8v-8.4H99c0-1,0.1-2,0.2-3H21.9 V48.9c0-4.4,3.6-8,8-8h108.3c4.4,0,8,3.6,8,8v23.8c1,0,2,0.1,3,0.3v-24C149.2,42.8,144.3,37.9,138.2,37.9z M75.8,135.7h16.5v12.6 H75.8V135.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M143.8,155.3c-20.9,0-37.9-17-37.9-37.9c0-20.9,17-37.9,37.9-37.9c20.9,0,37.9,17,37.9,37.9 C181.7,138.3,164.7,155.3,143.8,155.3z M143.8,82.5c-19.2,0-34.9,15.7-34.9,34.9c0,19.2,15.7,34.9,34.9,34.9 c19.2,0,34.9-15.7,34.9-34.9C178.7,98.2,163,82.5,143.8,82.5z"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M162.8,104.4c-0.2-0.1-0.3-0.2-0.5-0.2l-18-7.7c-0.4-0.2-0.8-0.2-1.2,0l-17.8,7.6c-0.2,0-0.4,0.1-0.5,0.2 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.5,0.6-0.5,1c0,0.2,0,0.4,0.1,0.5v21.9c0,0.6,0.3,1.1,0.9,1.4l17.8,8.5 c0.1,0.1,0.2,0.2,0.3,0.2c0.2,0.2,0.5,0.2,0.8,0.2c0.2,0,0.4,0,0.6-0.1l18.2-8.7c0.5-0.2,0.9-0.8,0.9-1.4v-22.5 C163.5,105.2,163.2,104.7,162.8,104.4z M143.7,99.5l14.6,6.2l-14.4,6.9l-14.6-7L143.7,99.5z M127.1,108.1l15.2,7.3v19l-15.2-7.3 V108.1z M160.5,127.3l-15.2,7.3v-19.2l15.2-7.3V127.3z"
});

var SvgVirtualizationEmpty = function SvgVirtualizationEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVirtualizationEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/virtualization_empty.57b0c0d1.svg";
export { ForwardRef as ReactComponent };